export const DropdownKeepOpenAttribute = 'data-dropdown-keep-open'
